import { css } from 'linaria';

export const BannersCarouselItemWrapper = css`
  @media (--only-mobile) {
    width: 70% !important;
  }
`;
